import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../auth/AdminAuthContext';
import LoginPage from './LoginPage';

export default function AdminLoginScreen() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = (email, password, nav) => {
    return login(email, password, nav, { redirectTo: location.state?.from });
  };

  return (
    <LoginPage
      onLogin={handleLogin}
      onRegister={() => navigate('/admin/register')}
    />
  );
}
